module.exports = {
    lotties: {
        intro: require('../files/lotties/intro.json'),
        voicewave: require('../files/lotties/voicewave.json'),
        spin: {
            light: require('../files/lotties/spin.json'),
            dark: require('../files/lotties/spindark.json')
        },
        configure: require('../files/lotties/configure.json')
    }
}